import { render, staticRenderFns } from "./VTitle.vue?vue&type=template&id=393f12ca&"
import script from "./VTitle.vue?vue&type=script&lang=js&"
export * from "./VTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393f12ca')) {
      api.createRecord('393f12ca', component.options)
    } else {
      api.reload('393f12ca', component.options)
    }
    module.hot.accept("./VTitle.vue?vue&type=template&id=393f12ca&", function () {
      api.rerender('393f12ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/post-components/v-title/VTitle.vue"
export default component.exports